import OspreyApiHelper from './helper'

export default class OspreyAccounts {

    static get(path, params) {
        return OspreyApiHelper.genericGet(path, params)
    }

    static put(path, params) {
        return OspreyApiHelper.genericPut(path, params.account)
    }
}



// WEBPACK FOOTER //
// src/services/osprey-api/api-accounts.js